/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 12/24/2019
 *
 */

import React from 'react';
import '../../../modals/modalView.css';
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";

/**
 * functional component for InputTextField
 * @param inputType
 * @param labelName
 * @param inputName
 * @param placeholder
 * @param required
 * @param value
 * @param handleChange
 * @returns {*}
 * @constructor
 */
const InputTextField = ({inputType, labelName, inputName, placeholder, required, value, handleChange, isDisabled,style}) => {
    if (value === null) value = '';

    let input = null;
    switch (inputType) {
        case 'textUrl':
            input =
                <div className="input-container">
                    <div className="content">
                        <input type='text'
                               name={inputName}
                               required={required}
                               autoComplete="off"
                               placeholder={placeholder}
                               value={value}
                               onChange={handleChange}
                               aria-label={inputName}
                               disabled={isDisabled}
                               style={style} // Apply inline style
                        />
                    </div>
                    <span className="icon"
                          onClick={() => {
                              EventEmitter.emit('openUrlViewer', true);
                              EventEmitter.emit('urlViewerData', {data: value})
                          }}>
                        <i className="fa fa-bars"/>
                    </span>
                </div>;
            break;
        case 'textPassword':
            input =
                <input type='password'
                       name={inputName}
                       required={required}
                       autoComplete="off"
                       placeholder={placeholder}
                       value={value}
                       onChange={handleChange}
                       aria-label={inputName}
                       disabled={isDisabled}
                />;
            break;
        case 'tpiAuditText':
            input =
                <input type='input'
                       name={inputName}
                       required={required}
                       autoComplete="off"
                       placeholder={placeholder}
                       value={value}
                       onChange={handleChange}
                       aria-label={inputName}
                       disabled={isDisabled}
                       onKeyPress={event => {
                           if (event.keyCode === 13 || event.which === 13) {
                               event.preventDefault();
                           }
                       }}
                />;
            break;
        default:
            input =
                <input type={inputType}
                       name={inputName}
                       required={required}
                       autoComplete="off"
                       placeholder={placeholder}
                       value={value}
                       onChange={handleChange}
                       aria-label={inputName}
                       disabled={isDisabled}
                />;
    }
    return(
        <div>
            <label>
                {labelName}
            </label>
            {input}
        </div>
    );
};

export default InputTextField;
